var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.849,14.5A2.573,2.573,0,0,1,24.5,12.1a10.2,10.2,0,0,0-1.234-2.973,2.609,2.609,0,0,1-1.047.224A2.567,2.567,0,0,1,19.87,5.734,10.172,10.172,0,0,0,16.9,4.5a2.572,2.572,0,0,1-4.8,0A10.2,10.2,0,0,0,9.125,5.734,2.567,2.567,0,0,1,6.776,9.348a2.524,2.524,0,0,1-1.047-.224A10.423,10.423,0,0,0,4.5,12.1a2.572,2.572,0,0,1,.005,4.8A10.2,10.2,0,0,0,5.74,19.876a2.569,2.569,0,0,1,3.391,3.39A10.262,10.262,0,0,0,12.1,24.5a2.567,2.567,0,0,1,4.792,0,10.2,10.2,0,0,0,2.974-1.234,2.571,2.571,0,0,1,3.391-3.39A10.257,10.257,0,0,0,24.495,16.9,2.585,2.585,0,0,1,22.849,14.5Zm-8.3,4.16a4.166,4.166,0,1,1,4.167-4.166A4.165,4.165,0,0,1,14.547,18.658Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.73e4c8df7dd41b794f3f7d15896a429d.svg";
export { ForwardRef as ReactComponent };